function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignInIllustration2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-159"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 260.3,
    cy: 361.61,
    rx: 199.51,
    ry: 115.19,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-159"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-159",
    cx: 289.89,
    cy: 369.29,
    rx: 52.58,
    ry: 28.37,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.14,305.92,153.55,418.26a7.88,7.88,0,0,1-7.17,0L86.3,383.57c-2-1.14-2-3,0-4.13L280.88,267.09a7.94,7.94,0,0,1,7.17,0l60.09,34.69C350.12,302.92,350.12,304.78,348.14,305.92Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.46,339.77l-7.9-4.52s-9.54-21.33-7.85-39.42c2.1-22.49,12.72-30.39,19-27.88s4.95,11.46-1.66,23.48C402.77,301,399.44,326.44,406.46,339.77Z",
    style: {
      fill: "#6B2FE0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.46,339.77l-7.9-4.52s-9.54-21.33-7.85-39.42c2.1-22.49,12.72-30.39,19-27.88s4.95,11.46-1.66,23.48C402.77,301,399.44,326.44,406.46,339.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.29,337.3a.49.49,0,0,1-.47-.34c-6.93-21.21-7.21-51,5.89-64.42a.49.49,0,1,1,.7.68c-12.37,12.68-12.59,42.21-5.66,63.44a.5.5,0,0,1-.31.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.38,352.43c1.24.72,3.82-.85,4.8-1.51a11.83,11.83,0,0,0,4-4.55,11.15,11.15,0,0,0,1-6.71,25.6,25.6,0,0,0-.85-3.56c-.33-1.15-.66-2.31-1-3.46a8.91,8.91,0,0,1-.5-3.49c.3-2.37,2.4-4,4.31-5.46,2.11-1.58,4.31-3.67,4.3-6.52a10,10,0,0,0-2.51-6c-1.36-1.73-3-3.25-4.21-5.07a7,7,0,0,1-1.44-4.43,7.34,7.34,0,0,1,1-2.77,38.81,38.81,0,0,0,3-5.55c.69-2,.59-4.47-1-5.9-1.28-1.17-3.18-1.33-4.91-1.22a11.29,11.29,0,0,0-4.56,1.61c-4.52,2.52-7.1,7.87-11.9,9.81a47.79,47.79,0,0,1-5.81,1.42c-1.93.51-3.9,1.5-4.8,3.28-1.76,3.52,1.51,7.86.27,11.59-1.09,3.31-4.31,4.58-6.11,7.56a7,7,0,0,0-.84,4.32,20.73,20.73,0,0,0,1.82,7.32,52.13,52.13,0,0,0,4,6.59C406.53,339.84,428.18,352.32,428.38,352.43Z",
    style: {
      fill: "#6B2FE0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,345.44A.49.49,0,0,1,415,345c-2.33-18.47,6.49-43.38,19.65-55.53a.49.49,0,1,1,.66.72c-13,12-21.64,36.49-19.34,54.69a.49.49,0,0,1-.42.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.7,321.81a.47.47,0,0,1-.39-.19.49.49,0,0,1,.09-.69c7.27-5.45,18.37-4.5,18.84-4.45a.48.48,0,0,1,.44.53.49.49,0,0,1-.53.44c-.11,0-11.2-1-18.16,4.26A.46.46,0,0,1,417.7,321.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.79,317.28a.49.49,0,0,1-.49-.47c-.33-8.46-6.72-13.57-6.78-13.62a.48.48,0,0,1-.08-.68.49.49,0,0,1,.68-.09,20.37,20.37,0,0,1,7.16,14.36.48.48,0,0,1-.47.5Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tree--inject-159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree--inject-159"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.66,
    y: 164.07,
    width: 4.45,
    height: 54.49,
    transform: "translate(-73.83 74.08) rotate(-26.91)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.34,
    y: 180.5,
    width: 45.69,
    height: 4.45,
    transform: "translate(-87.54 208.3) rotate(-58.24)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5,157.51V333.35a1.84,1.84,0,0,0,1.09,1.52,5.83,5.83,0,0,0,5.27,0,1.84,1.84,0,0,0,1.09-1.52V157.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.76,
    cy: 132.66,
    r: 42.78,
    transform: "translate(-66.91 180.78) rotate(-76.72)",
    style: {
      fill: "#6B2FE0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.74,137.66c-12.28-21-8.74-38.13-7.06-42.23,2.71-6.62,13.41-5.55,21.08-5.55a42.78,42.78,0,1,1-33,70C60.43,163.59,78.67,158.07,66.74,137.66Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.02,
    cy: 136.46,
    r: 38.22,
    transform: "translate(4.31 278.36) rotate(-76.72)",
    style: {
      fill: "#6B2FE0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,98.24a38,38,0,0,1,22.33,7.21c1,23.34-18.78,46.11-13.24,53.76s19.19,2.95,23.94-3.54a38.22,38.22,0,1,1-33-57.43Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.22,
    cy: 95.25,
    r: 70.11,
    style: {
      fill: "#6B2FE0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.14,47.08a70.27,70.27,0,0,1,1.86,16c0,38.73-19.37,80.12-71.12,80.12-20.06,0-43.75-13-49.9-31.93a69.53,69.53,0,0,0,7.54,19h0c.47.83,1,1.64,1.47,2.44a.36.36,0,0,1,.07.1,70.42,70.42,0,0,0,8.63,11l.37.39c.53.54,1.06,1.06,1.6,1.58l.62.59c.52.49,1,1,1.57,1.43l.74.64c.52.45,1.05.9,1.59,1.33.25.21.51.4.77.61.55.43,1.1.86,1.66,1.28l.47.33c1.15.84,2.33,1.64,3.53,2.4l.92.59,1.51.89,1.22.7c.49.27,1,.53,1.49.79s.88.46,1.33.69l1.47.71,1.43.64c.49.22,1,.43,1.46.63s1,.42,1.56.62.93.37,1.4.54c.68.24,1.37.47,2,.69l1.83.57c.7.21,1.4.41,2.11.6.46.12.93.22,1.39.33s1.18.29,1.78.41,1,.2,1.47.29,1.17.22,1.75.32l1.51.23,1.79.23,1.5.16c.63.06,1.27.1,1.91.14l1.42.1c.83,0,1.67.05,2.51.06l.79,0A70.09,70.09,0,0,0,181.14,47.08Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.55,64.85l7.45,4.3a8.22,8.22,0,0,1-.06-1V66c0-3.84,2.69-5.4,6-3.48A11.71,11.71,0,0,1,420.54,66c.55-4.83,4.34-6.62,8.94-4,5,2.87,9,9.86,9,15.6v3.23a8.47,8.47,0,0,1-.76,3.74l6.18,3.57a7.35,7.35,0,0,1,3.34,5.78c0,2.13-1.49,3-3.34,1.93l-40.35-23.3a7.38,7.38,0,0,1-3.34-5.78C400.21,64.65,401.71,63.79,403.55,64.85Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.63,64.44l9,5.17a9.48,9.48,0,0,1-.08-1.18v-2.6c0-4.63,3.25-6.5,7.25-4.19a14,14,0,0,1,4.32,4.16c.66-5.82,5.22-8,10.76-4.78,6,3.45,10.85,11.87,10.85,18.78v3.89a10.18,10.18,0,0,1-.92,4.5l7.45,4.3a8.92,8.92,0,0,1,4,7c0,2.56-1.8,3.6-4,2.32l-48.6-28.06a8.88,8.88,0,0,1-4-7C344.61,64.19,346.41,63.15,348.63,64.44Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bench--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.07,302.76a4.07,4.07,0,0,1-2.06-.56l-44.4-25.63a15.81,15.81,0,0,1-7.87-13.63V211.66a4.12,4.12,0,1,1,8.24,0v51.28a7.53,7.53,0,0,0,3.75,6.49l44.4,25.64a4.12,4.12,0,0,1-2.06,7.69Z",
    style: {
      fill: "#6B2FE0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.43,353.93a4.07,4.07,0,0,1-2.06-.56L101,327.74a15.79,15.79,0,0,1-7.87-13.63V262.84a4.12,4.12,0,0,1,8.24,0v51.27a7.51,7.51,0,0,0,3.75,6.49l44.4,25.64a4.12,4.12,0,0,1-2.06,7.69Z",
    style: {
      fill: "#6B2FE0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.6,251.2a4.07,4.07,0,0,1-2.06-.56L279.14,225a15.8,15.8,0,0,1-7.86-13.63V160.11a4.12,4.12,0,0,1,8.24,0v51.27a7.49,7.49,0,0,0,3.75,6.49l44.4,25.64a4.13,4.13,0,0,1-2.07,7.69Z",
    style: {
      fill: "#6B2FE0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.11,348.82v58.67a2.32,2.32,0,0,1-1.37,1.92,7.35,7.35,0,0,1-6.62,0,2.34,2.34,0,0,1-1.37-1.92V348.82Z",
    style: {
      fill: "#6B2FE0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,326.51v58.68a2.34,2.34,0,0,1-1.37,1.91,7.35,7.35,0,0,1-6.62,0,2.34,2.34,0,0,1-1.37-1.91V326.51Z",
    style: {
      fill: "#6B2FE0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.13,246v58.67a2.34,2.34,0,0,1-1.37,1.91,7.29,7.29,0,0,1-6.62,0,2.34,2.34,0,0,1-1.37-1.91V246Z",
    style: {
      fill: "#6B2FE0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,223.73V282.4a2.32,2.32,0,0,1-1.37,1.91,7.29,7.29,0,0,1-6.62,0,2.3,2.3,0,0,1-1.37-1.91V223.73Z",
    style: {
      fill: "#6B2FE0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.07,302.76a4.07,4.07,0,0,1-2.06-.56l-44.4-25.63a15.81,15.81,0,0,1-7.87-13.63V211.66a4.12,4.12,0,1,1,8.24,0v51.28a7.53,7.53,0,0,0,3.75,6.49l44.4,25.64a4.12,4.12,0,0,1-2.06,7.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.43,353.93a4.07,4.07,0,0,1-2.06-.56L101,327.74a15.79,15.79,0,0,1-7.87-13.63V262.84a4.12,4.12,0,0,1,8.24,0v51.27a7.51,7.51,0,0,0,3.75,6.49l44.4,25.64a4.12,4.12,0,0,1-2.06,7.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.6,251.2a4.07,4.07,0,0,1-2.06-.56L279.14,225a15.8,15.8,0,0,1-7.86-13.63V160.11a4.12,4.12,0,0,1,8.24,0v51.27a7.49,7.49,0,0,0,3.75,6.49l44.4,25.64a4.13,4.13,0,0,1-2.07,7.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.11,348.82v58.67a2.32,2.32,0,0,1-1.37,1.92,7.35,7.35,0,0,1-6.62,0,2.34,2.34,0,0,1-1.37-1.92V348.82Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,326.51v58.68a2.34,2.34,0,0,1-1.37,1.91,7.35,7.35,0,0,1-6.62,0,2.34,2.34,0,0,1-1.37-1.91V326.51Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.13,246v58.67a2.34,2.34,0,0,1-1.37,1.91,7.29,7.29,0,0,1-6.62,0,2.34,2.34,0,0,1-1.37-1.91V246Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,223.73V282.4a2.32,2.32,0,0,1-1.37,1.91,7.29,7.29,0,0,1-6.62,0,2.3,2.3,0,0,1-1.37-1.91V223.73Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.92,274.47,83.1,274a5.28,5.28,0,0,1-2.38-4.12v-7.39a5.25,5.25,0,0,1,2.38-4.12l195.71-113a5.32,5.32,0,0,1,4.76,0l.82.48a5.27,5.27,0,0,1,2.38,4.12v7.39a5.27,5.27,0,0,1-2.38,4.12l-195.71,113A5.25,5.25,0,0,1,83.92,274.47Z",
    style: {
      fill: "#6B2FE0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.39,148.6l-195.71,113a5.25,5.25,0,0,0-2.38,4.12v7.39c0,1.51,1.07,2.13,2.38,1.37l195.71-113a5.27,5.27,0,0,0,2.38-4.12V150C286.77,148.45,285.7,147.84,284.39,148.6Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.39,145.85l-.82-.48a5.32,5.32,0,0,0-4.76,0L83.1,258.37a4.71,4.71,0,0,0-1.68,1.77L87,263.36a5.15,5.15,0,0,1,1.68-1.77l195.71-113c1.31-.76,2.38-.15,2.38,1.37A5.27,5.27,0,0,0,284.39,145.85Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3,265.71a4.9,4.9,0,0,1,.7-2.35l-5.58-3.22a6,6,0,0,0-.44,1,4.29,4.29,0,0,0-.25,1.38v7.39a4.91,4.91,0,0,0,.72,2.39A4.83,4.83,0,0,0,83.1,274l.32.19.51.28a3,3,0,0,0,.36.18l.1.05.33.11.21.06.33.07.25,0,.33,0h.61l.22,0,.39,0,.09,0a4.55,4.55,0,0,0,1-.25,2.29,2.29,0,0,1-.34.07h0a1.2,1.2,0,0,1-.38,0l-.1,0-.24-.08-.09-.06a1,1,0,0,1-.19-.17.46.46,0,0,1-.07-.07,1.32,1.32,0,0,1-.16-.25.3.3,0,0,1,0-.08,2.23,2.23,0,0,1-.13-.39v0a2.78,2.78,0,0,1,0-.52Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.92,297.07l-.82-.48a5.27,5.27,0,0,1-2.38-4.12v-7.39A5.27,5.27,0,0,1,83.1,281L278.81,168a5.25,5.25,0,0,1,4.76,0l.82.47a5.28,5.28,0,0,1,2.38,4.13V180a5.28,5.28,0,0,1-2.38,4.12l-195.71,113A5.25,5.25,0,0,1,83.92,297.07Z",
    style: {
      fill: "#6B2FE0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.39,171.19l-195.71,113a5.25,5.25,0,0,0-2.38,4.12v7.39c0,1.51,1.07,2.13,2.38,1.37l195.71-113a5.27,5.27,0,0,0,2.38-4.12v-7.39C286.77,171.05,285.7,170.44,284.39,171.19Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.39,168.45l-.82-.48a5.32,5.32,0,0,0-4.76,0L83.1,281a4.81,4.81,0,0,0-1.68,1.78L87,286a5.15,5.15,0,0,1,1.68-1.77l195.71-113c1.31-.75,2.38-.14,2.38,1.38A5.27,5.27,0,0,0,284.39,168.45Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3,288.31A4.9,4.9,0,0,1,87,286l-5.58-3.22a5.92,5.92,0,0,0-.44,1,4.35,4.35,0,0,0-.25,1.39v7.39a5,5,0,0,0,.72,2.39,4.91,4.91,0,0,0,1.65,1.73l.32.18.51.29a3,3,0,0,0,.36.17l.1.05.33.11.21.07.33.07.25,0,.33,0,.26,0h.57l.39,0h.09a5.21,5.21,0,0,0,1-.25l-.34.06h0a1.59,1.59,0,0,1-.38,0l-.1,0a1.17,1.17,0,0,1-.24-.09l-.09-.06-.19-.16a.27.27,0,0,1-.07-.08,1.07,1.07,0,0,1-.16-.25.25.25,0,0,1,0-.07,2.23,2.23,0,0,1-.13-.39v0a2.78,2.78,0,0,1,0-.52Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.92,319.66l-.82-.47a5.27,5.27,0,0,1-2.38-4.12v-7.39a5.27,5.27,0,0,1,2.38-4.12l195.71-113a5.25,5.25,0,0,1,4.76,0l.82.47a5.27,5.27,0,0,1,2.38,4.12v7.39a5.27,5.27,0,0,1-2.38,4.12l-195.71,113A5.25,5.25,0,0,1,83.92,319.66Z",
    style: {
      fill: "#6B2FE0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.39,193.79l-195.71,113a5.25,5.25,0,0,0-2.38,4.12v7.39c0,1.51,1.07,2.13,2.38,1.37l195.71-113a5.27,5.27,0,0,0,2.38-4.12v-7.39C286.77,193.64,285.7,193,284.39,193.79Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.39,191l-.82-.48a5.32,5.32,0,0,0-4.76,0L83.1,303.55a4.81,4.81,0,0,0-1.68,1.78L87,308.55a5.15,5.15,0,0,1,1.68-1.77l195.71-113c1.31-.76,2.38-.15,2.38,1.37A5.27,5.27,0,0,0,284.39,191Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3,310.9a4.9,4.9,0,0,1,.7-2.35l-5.58-3.22a5.92,5.92,0,0,0-.44,1,4.35,4.35,0,0,0-.25,1.39v7.39a5,5,0,0,0,.72,2.39,4.91,4.91,0,0,0,1.65,1.73l.32.18.51.29a3,3,0,0,0,.36.17l.1.05.33.11.21.07.33.07.25,0,.33,0,.26,0h.57l.39,0h.09a5.21,5.21,0,0,0,1-.25l-.34.06h0a1.59,1.59,0,0,1-.38,0l-.1,0a1.17,1.17,0,0,1-.24-.09l-.09-.06-.19-.16a.27.27,0,0,1-.07-.08,1.07,1.07,0,0,1-.16-.25.25.25,0,0,1,0-.07,2.23,2.23,0,0,1-.13-.39v0a2.78,2.78,0,0,1,0-.52Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.93,355.89v.95a5.27,5.27,0,0,0,2.38,4.12l6.4,3.69a5.25,5.25,0,0,0,4.76,0l195.71-113a5.27,5.27,0,0,0,2.38-4.12v-.95a5.28,5.28,0,0,0-2.38-4.12l-6.4-3.69a5.25,5.25,0,0,0-4.76,0l-195.71,113A5.27,5.27,0,0,0,130.93,355.89Z",
    style: {
      fill: "#6B2FE0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.47,358.21l195.71-113c1.31-.76,1.31-2,0-2.75l-6.4-3.69a5.25,5.25,0,0,0-4.76,0l-195.71,113c-1.31.76-1.31,2,0,2.75l6.4,3.69A5.25,5.25,0,0,0,144.47,358.21Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.42,242.62c1.06.77,1,1.89-.24,2.6l-195.71,113a4.87,4.87,0,0,1-2.38.57v6.44a4.87,4.87,0,0,0,2.38-.57l195.71-113a5.27,5.27,0,0,0,2.38-4.12v-.95A5.32,5.32,0,0,0,340.42,242.62Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.71,358.21l-6.4-3.7c-1.15-.67-1.29-1.69-.43-2.44a5.29,5.29,0,0,0-1.95,3.82v.94a5.33,5.33,0,0,0,1.45,3.38,4.26,4.26,0,0,0,.93.74l6.4,3.7a4.87,4.87,0,0,0,2.38.57v-6.44A4.87,4.87,0,0,1,139.71,358.21Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.41,344.62v.95a5.26,5.26,0,0,0,2.38,4.12l6.4,3.69a5.23,5.23,0,0,0,4.75,0l195.71-113a5.27,5.27,0,0,0,2.38-4.12v-1a5.27,5.27,0,0,0-2.38-4.12l-6.4-3.69a5.25,5.25,0,0,0-4.76,0l-195.7,113A5.24,5.24,0,0,0,111.41,344.62Z",
    style: {
      fill: "#6B2FE0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.94,346.94,320.65,234c1.31-.76,1.31-2,0-2.75l-6.4-3.69a5.25,5.25,0,0,0-4.76,0l-195.7,113c-1.32.76-1.32,2,0,2.74l6.4,3.7A5.23,5.23,0,0,0,124.94,346.94Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.89,231.35c1.06.77,1,1.89-.24,2.6l-195.71,113a4.87,4.87,0,0,1-2.38.57V354a4.87,4.87,0,0,0,2.38-.57l195.71-113a5.27,5.27,0,0,0,2.38-4.12v-1A5.32,5.32,0,0,0,320.89,231.35Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.18,346.94l-6.4-3.7c-1.15-.67-1.29-1.69-.43-2.44a5.29,5.29,0,0,0-1.95,3.82v.94a5.33,5.33,0,0,0,1.45,3.38,4.26,4.26,0,0,0,.93.74l6.4,3.7a4.87,4.87,0,0,0,2.38.57v-6.44A4.87,4.87,0,0,1,120.18,346.94Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.88,333.34v1a5.24,5.24,0,0,0,2.38,4.12l6.4,3.7a5.25,5.25,0,0,0,4.76,0l195.7-113A5.26,5.26,0,0,0,303.5,225v-.95a5.24,5.24,0,0,0-2.38-4.12l-6.4-3.7a5.23,5.23,0,0,0-4.75,0l-195.71,113A5.26,5.26,0,0,0,91.88,333.34Z",
    style: {
      fill: "#6B2FE0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.26,332l6.4,3.7a5.32,5.32,0,0,0,4.76,0l195.7-113c1.32-.75,1.32-2,0-2.74l-6.4-3.7a5.23,5.23,0,0,0-4.75,0l-195.71,113C92.94,330,92.94,331.21,94.26,332Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.37,220.08c1.06.77,1,1.89-.24,2.6l-195.71,113a4.87,4.87,0,0,1-2.38.57v6.44a4.87,4.87,0,0,0,2.38-.57l195.71-113a5.27,5.27,0,0,0,2.38-4.12v-.95A5.32,5.32,0,0,0,301.37,220.08Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.66,335.67l-6.4-3.7c-1.15-.67-1.29-1.69-.43-2.44a5.29,5.29,0,0,0-2,3.82v.94a5.33,5.33,0,0,0,1.45,3.38,4.26,4.26,0,0,0,.93.74l6.4,3.7a4.87,4.87,0,0,0,2.38.57v-6.44A4.87,4.87,0,0,1,100.66,335.67Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.92,324.77a.82.82,0,0,0,0,1.55,3,3,0,0,0,2.69,0,.82.82,0,0,0,0-1.55A3,3,0,0,0,109.92,324.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.51,336.13a.82.82,0,0,0,0,1.56,3,3,0,0,0,2.69,0,.82.82,0,0,0,0-1.56A3,3,0,0,0,129.51,336.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.09,347.5a.82.82,0,0,0,0,1.55,3,3,0,0,0,2.69,0,.82.82,0,0,0,0-1.55A3,3,0,0,0,149.09,347.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.94,222.05a.82.82,0,0,0,0,1.55,3,3,0,0,0,2.69,0,.82.82,0,0,0,0-1.55A3,3,0,0,0,287.94,222.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.52,233.41a.83.83,0,0,0,0,1.56,3,3,0,0,0,2.69,0,.82.82,0,0,0,0-1.56A3,3,0,0,0,307.52,233.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.11,244.78a.82.82,0,0,0,0,1.55,3,3,0,0,0,2.69,0,.82.82,0,0,0,0-1.55A3,3,0,0,0,327.11,244.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.41,273.61a.82.82,0,0,0,0,1.55,3,3,0,0,0,2.69,0,.82.82,0,0,0,0-1.55A3,3,0,0,0,200.41,273.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,285a.82.82,0,0,0,0,1.55,3,3,0,0,0,2.69,0c.75-.42.75-1.12,0-1.55A3,3,0,0,0,220,285Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,296.34a.82.82,0,0,0,0,1.55,3,3,0,0,0,2.69,0,.82.82,0,0,0,0-1.55A3,3,0,0,0,239.57,296.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.22,261.07a3.39,3.39,0,0,0-1.53,2.65c0,1,.69,1.37,1.53.89A3.38,3.38,0,0,0,98.75,262C98.75,261,98.07,260.58,97.22,261.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.22,283.62a3.39,3.39,0,0,0-1.53,2.65c0,1,.69,1.37,1.53.88a3.35,3.35,0,0,0,1.53-2.65C98.75,283.52,98.07,283.13,97.22,283.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.22,306.17a3.38,3.38,0,0,0-1.53,2.65c0,1,.69,1.37,1.53.88a3.37,3.37,0,0,0,1.53-2.65C98.75,306.07,98.07,305.68,97.22,306.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.4,158.39a3.39,3.39,0,0,0-1.54,2.65c0,1,.69,1.38,1.54.89a3.41,3.41,0,0,0,1.53-2.65C276.93,158.3,276.24,157.9,275.4,158.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.4,180.94a3.39,3.39,0,0,0-1.54,2.65c0,1,.69,1.38,1.54.89a3.41,3.41,0,0,0,1.53-2.66C276.93,180.85,276.24,180.45,275.4,180.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.4,203.49a3.38,3.38,0,0,0-1.54,2.65c0,1,.69,1.37,1.54.89a3.41,3.41,0,0,0,1.53-2.66C276.93,203.4,276.24,203,275.4,203.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.86,210a3.41,3.41,0,0,0-1.53,2.65c0,1,.69,1.38,1.53.89a3.38,3.38,0,0,0,1.53-2.65C189.39,209.86,188.71,209.46,187.86,210Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.86,232.5a3.41,3.41,0,0,0-1.53,2.65c0,1,.69,1.37,1.53.89a3.38,3.38,0,0,0,1.53-2.66C189.39,232.41,188.71,232,187.86,232.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.86,255.05a3.39,3.39,0,0,0-1.53,2.65c0,1,.69,1.37,1.53.88a3.35,3.35,0,0,0,1.53-2.65C189.39,255,188.71,254.56,187.86,255.05Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362,146.84c-4.86-4.89-6.59-3-7.21,2.38a24.12,24.12,0,0,1-1.62,6.56,12.09,12.09,0,0,0-.91-3.24,2.37,2.37,0,0,0-2.88-1.42c-.48.2.11,1.34,0,3.42-.09,2.66-.95,4.13-.33,7a4.5,4.5,0,0,1-.48,3.11c-2.62,4.85-11,13.83-16.87,20.29l-22.43-20.26c-7.66-6.89-10.15-10-17.55-9.49a19.87,19.87,0,0,1,6.29,3.77c3.43,2.9,2.62,19.5,2.62,19.5s25.45,18.26,28.07,20c.39.26.78.49,1.17.7a6.27,6.27,0,0,0,7.63-1.47c5.43-6.21,13.35-18.43,17.93-24.79a76.92,76.92,0,0,0,5.53-9.64C365.5,154.24,365,149.91,362,146.84Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.31,153.42H281.67a16.93,16.93,0,0,1-16.93-16.93v-7.71A20.81,20.81,0,0,1,285.55,108h0a19.76,19.76,0,0,1,19.76,19.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.46,356.48a47.87,47.87,0,0,0-.74,7.82c-.09,4.75-1,6.43-1.08,10.33-.13,4.45.63,6.11,2.44,8.61s6.55,4.77,8.55.55,1.75-7,1.1-11.37-.74-7-1.13-10.45c-.33-3-.74-5.33-.74-5.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.93,319.17l-15.63-.29c.23,10.44,1.89,27.81,2.16,37.6.05,1.85,0,14.33.65,18.12,1,5.7,7.81,4.93,8.17,1.52s-.44-18-.42-19.48c-.06-6.28,2.89-22.67,4.43-33.95C275.36,322.14,275.86,319.71,275.93,319.17Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.91,348.36s-.81.05-.94.71-.18,2-.51,3.3a18.84,18.84,0,0,0-.56,6.19c.27,1.46,3.6,3.63,5.88,4s5.48,2.63,7.26,4.31a17.47,17.47,0,0,0,10.11,4c3.8,0,6.45-1.27,7.7-3.3s-1.14-2.28-5.48-5.1c-1-.64-2.11-1.36-3.37-2.19-6.88-4.49-9.4-6.89-11.34-11.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.71,345.92c-.11-3.23,1.54-27,1.54-27l-13.44,1.52c3.18,19,3.43,25.44,3.07,28.2h0a2.65,2.65,0,0,0-.08.79c0,3.69,4.17,5.68,7.42,8.14,1.28,1,4.57,4,8.43,5.27,2.5.85,7.12,1.18,7.71-.34-3.95-3-9.32-7-12.46-10.4C308.4,350.41,307.83,349.15,307.71,345.92Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.92,211.25c-7.33,16,.27,72.46.27,72.46-.22,2.6-3.19,7.72-4.3,19.16-1.31,13.52,2.41,49.72,2.41,49.72s3.58,2.67,8.76.18c0,0,9.46-53.18,11.16-66.62,1.48-11.74,4.32-37.54,4.32-37.54l8.07,37.47a70.12,70.12,0,0,0-2.56,11.58c-.76,7.91,6.94,47.6,6.94,47.6s3.6,1.9,8.72-.17c0,0,3.41-51.28,4.13-60.8,1.2-16-3-65.92-6-75.39Z",
    style: {
      fill: "#6B2FE0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.54,248.61l2.38-14.88s10.08-2.08,14.65-6.38c0,0-4.8,6-11.92,7.92L289,246.72l4.67,34.7Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.86,155.58h0c-9.4.65-10.06,5.19-12.41,10.16a16,16,0,0,0-.45,12.12l6.56,19s-3.07,7.42-6.64,14.43c16.45,9.18,37,4.35,41.93-2.35.21-1.42-1.06-12.53-1.84-19.78,2.9-7.27,3.66-11.88,2.44-16.68-2.27-8.92-11.08-17.6-15-17.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.36,118.25c3.1,1.7,5.83,6.41,5.55,18.13-.23,9.93-3.45,12.39-5.06,13.09s-4.74.28-7.77-.22v6s4.19,4.87,3.93,7.6-6.05,3.38-10,.71a25.24,25.24,0,0,1-6.44-6.74V142.37s-2.05,2.73-5.39.51-3.48-7.73-1.53-9.7,6.14-1.35,6.92,1.38c0,0,.19-2,1.28-2a25.21,25.21,0,0,0,9.51-2.66C295.75,125.81,296.35,122.31,297.36,118.25Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.43,129.86l-2.77-1.33a1.48,1.48,0,0,1,2-.76A1.62,1.62,0,0,1,300.43,129.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.39,128.27l-2.6,1.64a1.47,1.47,0,0,1,.42-2.1A1.62,1.62,0,0,1,288.39,128.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.49,131.82l.17,6.08a3,3,0,0,0,3-3A3.2,3.2,0,0,0,277.49,131.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.88,111.67,271,115a3,3,0,0,0-.75-4.21A3.2,3.2,0,0,0,265.88,111.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.66,107.5l-.48,6.06a2.94,2.94,0,0,0,3.32-2.68A3.19,3.19,0,0,0,271.66,107.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.64,133.5a1.25,1.25,0,1,1-1.32-1.24A1.29,1.29,0,0,1,289.64,133.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.08,142.3l2.9.93a1.49,1.49,0,0,1-1.88,1A1.61,1.61,0,0,1,291.08,142.3Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.85,133a1.26,1.26,0,0,1-1.18,1.35,1.3,1.3,0,1,1,1.18-1.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.2 132.26 293.39 139.78 297.35 138.56 293.2 132.26",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.08,149.25c-3.19-.42-9.77-2.31-10.79-4.91a6.75,6.75,0,0,0,2.3,3.32c2,1.68,8.49,3.58,8.49,3.58Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,213a9.92,9.92,0,0,1-7.4-12.1,3.17,3.17,0,0,1,.17-.52,3.24,3.24,0,0,1,3.33-2.21h0a9.56,9.56,0,0,1-4.11-6.13l-2-11.88a13.83,13.83,0,0,1,.5-5.76L265,166.77l-1.22.85a16.53,16.53,0,0,0,.27,10.24l6.56,19s-3.07,7.42-6.64,14.43c12.13,6.76,26.46,5.92,35.15,2.32A47.67,47.67,0,0,1,281.07,213Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,195.22c3.21-13.09,13-39,23.36-38.85,3,3.62,2.19,14.55-2.6,21.19,0,0-10.67,22.51-12.37,30.51-1.5,7-3.19,15.88-3.08,21.92a4.42,4.42,0,0,0,1.18,2.88c1.95,2.11,2,3.81,3.22,6.15,1,1.82,2.07,2.51,1.76,2.92a2.36,2.36,0,0,1-3.2.24,12.6,12.6,0,0,1-2.43-2.33,24.11,24.11,0,0,0,1.93,6.47c2.19,4.94,1.65,7.46-5,5.7-4.18-1.1-6.8-4.58-7.43-14.62a77.9,77.9,0,0,1-.11-11.11A230.22,230.22,0,0,1,249,195.22Z",
    style: {
      fill: "#ffa8a7"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInIllustration2);
export default __webpack_public_path__ + "static/media/sign_in_illustration_2.037d17a68f56bcb0d4d5bdc81ea733ba.svg";
export { ForwardRef as ReactComponent };